import React from 'react';

function PrivacyPolicy() {
    return (
        <div>
          <h1>Privacy Policy</h1>
          <p>
            This policy applies to all information collected or submitted on Sammy Javed's website and our apps for iPhone and any other devices and platforms.
          </p>
          

          <h3>Information we collect</h3>
          <p>
            We store the images uploaded for the morpher to function.  We also stored the final morphed image(s) on our server so the link to the morphed image remains valid.
          </p>
          
          <h3>Technical basics</h3>

          <p>Our server software may also store basic technical information, such as your IP address, in temporary memory or logs.</p>

          <h3>Ads and analytics</h3>
          <p>Sammy Javed's app collects aggregate, anonymous statistics, such as the percentage of users who use particular features, to improve the app.</p>

          <h3>Information usage</h3>
          <p>
            We use the information we collect to operate and improve our website, apps, and customer support.
            We do not share personal information with outside parties except to the extent necessary to accomplish core app functionality.

            We may disclose your information in response to subpoenas, court orders, or other legal requirements; to exercise our legal rights or defend against legal claims; to investigate, prevent, or take action regarding illegal activities, suspected fraud or abuse, violations of our policies; or to protect our rights and property.

            In the future, we may sell to, buy, merge with, or partner with other businesses. In such transactions, user information may be among the transferred assets.
          </p>

          
          <h3>Security</h3>
          <p>
          We implement a variety of security measures to help keep your information secure. For instance, all communication with the app and website requires HTTPS with certificate pinning.
          We may delete your information at any time and for any reason, such as technical needs, legal concerns, abuse prevention, removal of idle accounts, data loss, or any other reason.
          </p>

          <h3>Your Consent</h3>
          <p>By using our site or apps, you consent to our privacy policy.</p>

          <h3>Contacting Us</h3>
          <p>If you have questions regarding this privacy policy, you may email me@sammyjaved.com</p>

          <h3>Changes to this policy</h3>
          <p>If we decide to change our privacy policy, we will post those changes on this page.</p>
        </div>
    );
}



export default PrivacyPolicy;
